import { DefaultFetchService } from "../services/fetchService";

import { estimationsVsGaUserPreferencesUpdateSuccess } from "./commonActions";

/**
 * Created by Eyal.Albilia on 5/17/2017.
 */

export const estimationsVsGaUserPreferencesUpdate = (userData: { type: string; isEnabled: boolean }) => {
    const fetchService = DefaultFetchService.getInstance();
    return (dispatch: FixmeType) =>
        fetchService
            .post<any>("/api/userdata/dataviewpreferences/update", [
                {
                    Type: userData.type,
                    IsEnabled: userData.isEnabled,
                },
            ])
            .then((response) => {
                dispatch(estimationsVsGaUserPreferencesUpdateSuccess(response));
            })
            .catch((error) => {});
};
